module.exports = __webpack_public_path__ + "img/red_gold2.a287266e.png";